<template>
  <div class="home">
     <App-navigation></App-navigation>
     <v-container grid-list-lg>

        <v-layout row>
            <v-flex  class="text-xs-center display-1 font-weight-black ">
               Available movies currently in {{campus.toUpperCase()}} 
                           </v-flex>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              append-icon="mic"
              label="Search"
              solo-inverted
              class="mx-2"
              flat

            ></v-text-field>

            
        </v-layout>
        <v-layout row wrap>
            <v-flex class="text-xs-center display-3 font-weight-black my-3" >
              <v-data-table :headers="headers" :items="loads()" :search="search" :custom-filter="customFilter" hide-actions class="elevation-1">
                <template slot="items" slot-scope="{item}">
                  <td><b>{{item.sn}}</b></td>
                  <td class="text-xs-center">{{item.movName.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.category.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.slots}}</td>
                  <td class="text-xs-center">N{{item.price}}</td>
                  <td class="text-xs-center">{{item.vDate}}</td>
                  <td class="text-xs-center">{{item.vTime}}</td>
                  <td class="text-xs-center">{{item.useradd.toUpperCase()}}</td>
                  <td class="justify-center layout px-0">
                   <Sell-movie :name="item.name" :movName="item.movName" :category="item.category" :slots="item.slots" :price="item.price" :vDate="item.vDate" :vTime="item.vTime" :campus="campus" v-if="crc(staff.rights,'021')"></Sell-movie>
                   <Remove-movie :name="item.name" :movname="item.movName" :category="item.category" :campus="campus" v-if="crc(staff.rights,'020')"></Remove-movie>
                  </td>
                </template>
              </v-data-table>

            </v-flex>
        </v-layout>
     </v-container>
     
     <Link-movie v-if="crc(staff.rights,'019')" :campus="campus"></Link-movie>
  </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/Navigation/AppNavigation.vue'
import LinkMovie from '@/components/CampusMovie/LinkMovie.vue'
import RemoveMovie from '@/components/CampusMovie/RemoveMovie.vue'
import SellMovie from '@/components/CampusMovie/SellMovie.vue'

import {checkright} from '@/validator'
export default {
  name: 'staff',
  props: ['campus'],
  data(){
      return {
          staff:this.$store.getters.getStaff, 
          dialog:false,
          search:'',
          headers:[
            { 
              text:'S/N',
              align:'center',
              sortable:true,
              value:'sn'
            },
            {
              text:'MOVIE NAME',
              align:'center',
              sortable:true,
              value:'movName'
            },
            {
              text:'CATEGORY',
              align:'center',
              sortable:true,
              value:'category'
            },
            {
              text:'AVAILABLE SLOTS',
              align:'center',
              sortable:true,
              value:'slots'
            },
            {
              text:'PRICE',
              align:'center',
              sortable:true,
              value:'price'
            },
            {
              text:'VIEWING DATE',
              align:'center',
              sortable:true,
              value:'vDAte'
            },
            {
              text:'VIEWING TIME',
              align:'center',
              sortable:false,
              value:'vTime'
            },
            {
              text:'LINKED BY',
              align:'center',
              sortable:false,
              value:'useradd'
            },
            {
              text:'ACTION',
              sortable:false,
              value:''
            }
          ],
          editedIndex:-1,
          editedItem:{
              name:''
          },
          defaultItem:{
              
          },
          listPrimitive:null
      }
  },
  methods:{
         loads(){
           
            let self=this;
            let value;
            self.$store.dispatch('updateLinkedMovies',this.campus);
            value = self.$store.getters.getLinkedMovies;
            return value;
           
            
        },
    crc(array,value){
      return checkright(array,value);
    },
    customFilter(items,search){

     if(!search){ return items }
     function new_filter(val,search){
       return val !== null &&
        ['undefined','boolean'].indexOf(typeof val) === -1 &&
        val.toString().toLowerCase().replace( /[^0-9a-zA-Z]+/g ,'').indexOf(search) !== -1
     }

     let needleAry = search.toString().toLowerCase().split(" ").filter(x => x);

     return items.filter(row => needleAry.every(needle => Object.keys(row).some(key => new_filter(row[key],needle))));
    }
  },
  components: {
    AppNavigation,
    LinkMovie,
    RemoveMovie,
    SellMovie
  }
}
</script>
